export enum DomainBoolean {
  no = 0,
  yes = 1,
}
